import { Guid, IApiLink } from "@/types"
import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import dayjs, { Dayjs } from "utils/dayjs"

export interface IImage {
    fileId: Guid
    imageUri: string
    thumbnailUri?: string
    friendlyName: string
    deleteLink?: IApiLink
}

interface IImageDto {
    fileId: Guid
    imageUri: string
    thumbnailUri?: string
    friendlyName: string
    links?: IApiLink[]
}

export interface IGetImageCollectionDto {
    collectionDate?: string
    tags?: string[]
    images?: IImageDto[]
}

export interface IPostImageCollectionDto {
    submitDate?: Dayjs
    tags?: string[]
    fileIds: Guid
}

export default class ImageCollection {
    collectionDate?: Dayjs
    tags?: string[]
    images?: IImage[]

    constructor({
        collectionDate,
        tags,
        images
    }: IGetImageCollectionDto) {
        this.collectionDate = collectionDate ? dayjs(collectionDate) : undefined
        this.tags = tags
        this.images = images?.map(image => ({
            fileId: image.fileId,
            imageUri: image.imageUri,
            thumbnailUri: image.thumbnailUri,
            friendlyName: image.friendlyName,
            deleteLink: image.links?.find(link => link.entity === ApiLinkEntity.assetImage && link.rel === ApiLinkRel.delete),
        }))
    }
}
